import React from "react";
import { StandadCard } from "../../../../../components/Cards";
import {
  CustomSelect,
  CustomTypography,
} from "../../../../../components/formsComponents";
import { MenuItem, Box, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { IStoreState } from "../../../../../redux/initialStoreState";
import { fetchSalesLeadAnalyticsAsync, fetchFinanceAnalyticsAsync, fetchTransactionsAsync } from "../../../../../redux/dashboard/dashboardActions";
import { Skeleton } from "@mui/lab";
import { useAuth, userRoles } from "../../../../../contexts/AuthProvider/AuthProvider";
import {
  CalendarViewMonth,
  DateRange,
  Today,
  ViewWeek,
} from "@mui/icons-material";
import { dateFilterDates } from "../../../../../components/Table/helpers";
import { LoadState } from "../../../../../constants/enums";

const { today, startDateOfMonth, lastweek, tommorow, yesterday } =
  dateFilterDates();

export const UserTransactionCounter: React.FC<{ realTime?: boolean }> = ({
  realTime,
}) => {
  const [transactionHistoryStatus, setTransactionHistoryStatus] =
    React.useState<"ACTIVE" | "PENDING">("ACTIVE");
  const dispatch = useDispatch<any>();
  const user = useAuth();

  const { totalRecords: financeTotalRecords, loading: financeLoading, error: financeError } = useSelector((state: IStoreState) => state.dashboard.finance_analytics)
  const { totalRecords: salesLeadTotalRecords, loading: salesLeadLoading, error: salesLeadError } = useSelector((state: IStoreState) => state.dashboard.salesLead_analytics)

  // Call API only once in the parent component
  React.useEffect(() => {
    user.user.role === userRoles.SALES_TEAM_LEAD ? dispatch(fetchSalesLeadAnalyticsAsync(transactionHistoryStatus)) : dispatch(fetchFinanceAnalyticsAsync(transactionHistoryStatus))
  }, [transactionHistoryStatus])

  return (
    <StandadCard
      heading="Transactions History"
      rightHeading={
        <CustomSelect
          sx={{ width: "100%", minWidth: "150px" }}
          value={transactionHistoryStatus}
          onChange={(e) =>
            setTransactionHistoryStatus(e.target.value as "ACTIVE")
          }
        >
          <MenuItem value="ACTIVE">ACTIVE</MenuItem>
          <MenuItem value="PENDING">PENDING</MenuItem>
        </CustomSelect>
      }
    >
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <Row
            label="RSA Today"
            fromDate={today}
            todate={tommorow}
            status={transactionHistoryStatus}
            icon={<Today />}
            realTime={realTime}
            records={user.user.role === userRoles.SALES_TEAM_LEAD ? salesLeadTotalRecords : financeTotalRecords}
            loading={user.user.role === userRoles.SALES_TEAM_LEAD ? salesLeadLoading === LoadState.InProgress : financeLoading === LoadState.InProgress}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Row
            label="RSA Yesterday"
            fromDate={yesterday}
            todate={yesterday}
            status={transactionHistoryStatus}
            icon={<DateRange />}
            realTime={realTime}
            records={user.user.role === userRoles.SALES_TEAM_LEAD ? salesLeadTotalRecords : financeTotalRecords}
            loading={user.user.role === userRoles.SALES_TEAM_LEAD ? salesLeadLoading === LoadState.InProgress : financeLoading === LoadState.InProgress}
           />
        </Grid>

        <Grid item xs={12} md={3}>
          <Row
            label="RSA Last Week"
            fromDate={lastweek}
            todate={today}
            status={transactionHistoryStatus}
            icon={<ViewWeek />}
            realTime={realTime}
            records={user.user.role === userRoles.SALES_TEAM_LEAD ? salesLeadTotalRecords : financeTotalRecords}
            loading={user.user.role === userRoles.SALES_TEAM_LEAD ? salesLeadLoading === LoadState.InProgress : financeLoading === LoadState.InProgress}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Row
            label="RSA This Month"
            fromDate={startDateOfMonth}
            todate={today}
            status={transactionHistoryStatus}
            icon={<CalendarViewMonth />}
            realTime={realTime}
            records={user.user.role === userRoles.SALES_TEAM_LEAD ? salesLeadTotalRecords : financeTotalRecords}
            loading={user.user.role === userRoles.SALES_TEAM_LEAD ? salesLeadLoading === LoadState.InProgress : financeLoading === LoadState.InProgress}
          />
        </Grid>
      </Grid>
    </StandadCard>
  );
};

export const Row: React.FC<{
  label: string;
  fromDate: string;
  todate: string;
  status: "ACTIVE" | "PENDING";
  icon: React.ReactNode;
  realTime?: boolean;
  records: any;
  loading: boolean;
}> = (props) => {
  const { label, fromDate, todate, status, icon, realTime, records, loading } = props;


  return (
    <Box
      sx={{
        margin: "15px 0px",
        borderRight: "1px solid rgb(240, 240, 240)",
        pl: 3,
        pr: 3,
      }}
    >
      <Box display={"flex"} alignItems="center" justifyContent="space-between">
        <CustomTypography variant="h5" fontWeight="600">
          {label}
        </CustomTypography>
        {icon}
      </Box>
      <CustomTypography
        variant="body1"
        sx={{ mt: "0.5rem !important", fontSize: "0.9rem" }}
      >
        {loading ? <Skeleton width={20} /> : (() => {
          // Extract the appropriate value based on the label
          if (label.includes("Today")) {
            return records?.today || "0";
          } else if (label.includes("Yesterday")) {
            return records?.yesterday || "0";
          } else if (label.includes("Last Week")) {
            return records?.last_week || "0";
          } else if (label.includes("This Month")) {
            return records?.this_month || "0";
          }
 
          return "0";
        })()}
      </CustomTypography>
    </Box>
  );
};
